import { EmailAttachment } from '../email-attachment.model';
import { Component, Inject, OnInit, OnDestroy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ErrorList } from '../../../shared-components/controls/error-prompt/error-list.model';

// FileName: null,
// Base64String: null,
// IsFileUpload: false,
// FileType: null,
// OriginalFileName: null,
// FileExtension: null
@Component({
    selector: 'add-attachments',
    templateUrl: './add-attachments-dialog.component.html',
    styleUrls: [
        './add-attachments-dialog.component.css'
    ]
})
export class AddAttachmentsDialogComponent implements OnInit, OnDestroy {

    // Properties
    originalAttachments: EmailAttachment[];
    attachments: EmailAttachment[];
    totalAttachmentSize = 10485760;
    maxAttachmentSize = 10485760;
    errors: ErrorList[] = [];

    // Class Functions
    constructor (
        @Inject(MAT_DIALOG_DATA) private data: any,
        private dialogBox: MatDialogRef<AddAttachmentsDialogComponent>
    ) {}

    // Event Functions
    ngOnInit() {
        // PRE: injected data with a list of attachments
        // POST: initializes the data
        this.attachments = this.data.attachments;
        this.originalAttachments = [];
        this.attachments.forEach(attachment => {
            this.originalAttachments.push(Object.assign(new EmailAttachment(), attachment));
        });
        console.log(this.originalAttachments);
        this.determineMaxFileSize();
    }

    ngOnDestroy() {
        // POST: sets the original names of the files
        this.attachments.forEach(attachment => {
            attachment.OriginalFileName = attachment.FileName;
        });
    }

    setFileSize(attachment: EmailAttachment, size: number) {
        // PRE: the file is changed
        // POST: sets this attachments size and the size of all of our attachments

        // Setting this particular attachments size
        attachment.size = size;

        // Determining the size of all of our attachments
        this.determineMaxFileSize();
    }

    printAttachments(index: number, attachment: EmailAttachment) {
        console.log(index);
        console.log(attachment);
        console.log(this.attachments);
    }

    ok() {
        this.errors = [];
        for (let attachment of this.attachments.filter(a => a.Base64String)) {
            if (attachment.FileExtension.toLowerCase() != 'pdf' &&
                attachment.FileExtension.toLowerCase() != 'jpg' &&
                attachment.FileExtension.toLowerCase() != 'png' &&
                attachment.FileExtension.toLowerCase() != 'txt' &&
                attachment.FileExtension.toLowerCase() != 'doc' &&
                attachment.FileExtension.toLowerCase() != 'docx' &&
                attachment.FileExtension.toLowerCase() != 'xls' &&
                attachment.FileExtension.toLowerCase() != 'xlsx') {
                this.errors.push({
                    fieldRef: null,
                    fieldName: 'File',
                    errorMsg: 'Only .txt, .doc(x), .xls(x), .pdf, .jpg, and .png files can be uploaded.'
                });
                break;
            }
        }

        if (this.errors.length == 0)
            this.dialogBox.close(true);
    }

    cancel() {
        // PRE: the cancel button is clicked
        // POST: restores the attachments and closes the dialog box
		for (let i = 0; i < this.attachments.length; i++) {
			if (!this.originalAttachments[i].Base64String) {
				this.deleteAttachment(this.attachments[i]);
			} else {
				Object.assign(this.attachments[i], this.originalAttachments[i]);
			}
		}
        this.dialogBox.close(false);
    }

    // Methods
    determineMaxFileSize() {
        // POST: sets the maximum file zie
        let currentAttachmentSize = 0;
        for (let i = 0; i < this.attachments.length; i++) {
            if (this.attachments[i] && this.attachments[i].size) {
                currentAttachmentSize += this.attachments[i].size;
            }
        }
        this.maxAttachmentSize = this.totalAttachmentSize - currentAttachmentSize;
    }

    deleteAttachment(attachment: EmailAttachment) {
        // PRE: an attachment to delete
        // POST: clears the content of that attachment
        attachment.FileName = null;
        attachment.Base64String = null;
        attachment.FileType = null;
        attachment.FileExtension = null;
        attachment.OriginalFileName = null;
        attachment.IsFileUpload = undefined;
    }
}
